const SecondaryButton = ({
  children,
  onClick,
  className,
}: {
  children: string;
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <button
      onClick={onClick}
      className={`border-black hover:underline underline-offset-2 border w-72 min-w-full max-w-full px-2 py-3 ${className}`}
    >
      {children}
    </button>
  );
};

export default SecondaryButton;
